<script setup lang="ts">

const props = defineProps<{ content: string, headingLevel: string  }>();
const headingElement = `h${props.headingLevel}`;
</script>
<template>
<component :is="headingElement"  v-bind="{ innerHTML: content }" ></component>
</template>